import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getCompanyERPCodeMap = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-erpcode-map`, data);
        return await response.data;
    } catch (error) {
        console.log("getCompanyERPCodeMap - error", error)
        return handleApiError(error)
    }
}

export const getCompanyERPCodeMapDataById = async (companyERPCodeMapId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/company-erpcode-map/${companyERPCodeMapId}`);
        return await response.data;
    } catch (error) {
        console.log("getCompanyERPCodeMapDataById - error", error)
        return handleApiError(error)
    }
}

export const getCompanyERPCodeMapByCompanyId = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-erpcode-map/companyERPCodeMapByCompanyId`, data)
        return await response.data;
    } catch (error) {
        console.log("getCompanyERPCodeMapDataById - error", error)
        return handleApiError(error)
    }
}

export const getVMICompanyERPCodeMapByCompanyId = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-erpcode-map/vmi/materials`, data)
        return await response.data;
    } catch (error) {
        console.log("getVMICompanyERPCodeMapByCompanyId - error", error)
        return handleApiError(error)
    }
}

export const getCompanyERPCodeMapByCompanyIdAndBranchId = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-erpcode-map/companyid-and-branchid`, data)
        return await response.data;
    } catch (error) {
        console.log("getCompanyERPCodeMapByCompanyIdAndBranchId - error", error)
        return handleApiError(error)
    }
}


export const insertCompanyERPCodeMap = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-erpcode-map/create`, data);
        return await response.data;
    } catch (error) {
        console.log("insertCompanyERPCodeMap - error", error)
        return handleApiError(error)
    }
}
